<div class="ecertnl-confirm-modal">
  <div class="">
    <div class="modal-header pt-0">
      {{ data.headerText | promptvalue: false:data.headerTextFallback | async }}

      <img
        *ngIf="canLeave"
        class="icon float-right"
        src="assets/icons/ui-close-edit-box-hover-focus.svg"
        alt="sluiten"
        (click)="closeButton()"
      />
    </div>

    <div class="modal-body" [ngClass]="{ 'warning bg-geel mb-3': isWarning }">
      {{ data.messageText | promptvalue: false:data.messageTextFallback:data.messageTextParameters | async }}
    </div>

    <div class="row ecertnl-confirm-modal--row" style="overflow: hidden">
      <div class="col-6" [class.hidden]="hideNegativeButton()">
        <button id="negative_button" (click)="negativeButton()" class="w-100 button wit">
          {{ data.negativeButton | promptvalue: false:data.negativeButtonFallback | async }}
        </button>
      </div>
      <div class="col-6">
        <button id="positiveButton" (click)="positiveButton()" [disabled]="pageHasErrors" class="w-100 button float-right" #posButton>
          {{ data.positiveButton | promptvalue: false:data.positiveButtonFallback | async }}
        </button>
      </div>
    </div>
  </div>
</div>
